import React from "react";
import { Routes, Route } from "react-router-dom";
import PrivateRoute from "../Components/Authentication/privateRoute";

import ListAdmins from "../Components/Manage Admins/listAdmins";
import AddAdmins from "../Components/Manage Admins/addAdmins";
import EditAdmins from "../Components/Manage Admins/editAdmins";
import ViewAdmin from "../Components/Manage Admins/ViewAdmin";

const AdminRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/">
          <Route element={<PrivateRoute />}>
            <Route
              path="/manage_admins"
              element={<ListAdmins></ListAdmins>}
            ></Route>
            <Route
              path="/manage_admins/add"
              element={<AddAdmins></AddAdmins>}
            ></Route>
            <Route
              path="/manage_admins/edit/:id"
              element={<EditAdmins></EditAdmins>}
            ></Route>
            <Route
              path="/manage_admins/view/:id"
              element={<ViewAdmin/>}
            ></Route>
          </Route>
        </Route>
      </Routes>
    </div>
  );
};

export default AdminRoutes;
